import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectExpirationDate = (store: StoreSchema) => store.newApplicationState.newApplication.expirationDate